import React from 'react';
import PropTypes from 'prop-types';
import { compose, branch, renderNothing, mapProps, withProps } from 'recompose';

import * as timeplanUnitStyles from './timeplanUnitStyles.css';
import { InputGroup } from '..';
import setMileageAllowance from './setMileageAllowance';
import PaymentWarning from './TimeplanUnitPaymentWarning';
import { useTranslation } from 'react-i18next';

function MileageAllowance({ disabled, isEditable, kilometers, onChange, hasPayment }) {
  const { t } = useTranslation();
  if (!isEditable || disabled) {
    return (
      <div className={timeplanUnitStyles.timeplanUnitSummaries}>
        <table>
          <tbody>
            <tr className={timeplanUnitStyles.timeplanUnitSummary}>
              <td>{t("Milersättning")}</td>
              <td>{kilometers}km</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <React.Fragment>
      <PaymentWarning hasPayment={hasPayment} />
      <InputGroup
        label={t("Milersättning")}
        input={{
          name: 'kilometers',
          value: kilometers,
          onChange,
          onBlur: onChange,
          onFocus: (e) => {
            if (kilometers === 0) {
              e.target.select();
            }
          },
        }}
        inputAddonAfter="km"
        disabled={hasPayment}
      />
    </React.Fragment>
  );
}

MileageAllowance.defaultProps = {
  isEditable: false,
};

MileageAllowance.propTypes = {
  isEditable: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  kilometers: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  hasPayment: PropTypes.bool.isRequired,
};

export default compose(
  branch(({ mileageAllowances }) => mileageAllowances.size === 0,
    renderNothing,
  ),
  mapProps(({ mileageAllowances, ...props }) => ({
    mileageAllowance: mileageAllowances.first(),
    ...props,
  })),
  withProps(({ mileageAllowance, onChangeTimeplanUnits }) => ({
    kilometers: mileageAllowance.kilometers,
    onChange: kilometers =>
      onChangeTimeplanUnits(
        setMileageAllowance,
        mileageAllowance,
        { kilometers: parseInt(kilometers, 10) ? parseInt(kilometers, 10) : 0 },
      ),
    hasPayment: !!mileageAllowance.payment,
  })),
)(MileageAllowance);
